import Http from '@/api/http_v2.js'

export default {
  index(params) {
    return Http.get(`/pickup_locations`, { params })
  },
  show(id) {
    return Http.get(`/pickup_locations/${id}`);
  },
  update(pickup_location){
    return Http.put(`/pickup_locations/${pickup_location.id}`, { pickup_location })
  },
}
